import './More.less';
import { useTranslation } from 'react-i18next';
export default function More({ onClick, top = 0 }) {
  const { t } = useTranslation();
  return (
    <div className="more_block" onClick={onClick} style={{ marginTop: top }}>
      {t('As_Space_AddProj')} {'>>'}
    </div>
  );
}
